module.exports = __webpack_public_path__ + "img/whatsapp.2e2ad76f.svg";